/* Load once in theme.liquid. Each Quick view owns its own product embed. */
(() => {
  if (customElements.get('pc-qv-contentdriver')) return;
  let runtime;
  const getRuntime = () => runtime ||= import('https://cdn.contentdriver.com.au/runtime/index.js').catch(error => { runtime = null; throw error; });
  customElements.define('pc-qv-contentdriver', class extends HTMLElement {
    connectedCallback() {
      this.frame = requestAnimationFrame(() => this.init());
    }
    init() {
      if (!this.isConnected) return;
      this.fallback = this.querySelector('[data-pc-cd-fallback]');
      this.section = this.closest('[data-section-type="product"]');
      this.details = this.closest('details');
      if (!this.fallback || !this.details) return;
      this.controller?.abort();
      this.controller = new AbortController();
      this.details.addEventListener('toggle', () => { if (this.details.open) this.refresh(); }, { signal: this.controller.signal });
      this.observer?.disconnect();
      this.observer = new MutationObserver(() => { if (this.details.open) this.refresh(); });
      if (this.section) this.observer.observe(this.section, { subtree: true, childList: true, characterData: true });
      if (this.details.open) this.refresh();
    }
    refresh() {
      const skuNode = this.section?.querySelector('.product-meta__sku-number');
      const sku = (skuNode ? skuNode.textContent : this.dataset.sku || '').trim().toUpperCase();
      if (sku === this.currentSKU) return;
      this.currentSKU = sku;
      this.reset();
      if (sku) this.load(sku, this.version);
    }
    reset() {
      this.version = (this.version || 0) + 1;
      this.abort?.abort();
      clearTimeout(this.timeout);
      this.stage?.remove();
      this.stage = null;
      if (this.fallback) this.fallback.hidden = false;
    }
    async load(sku, version) {
      const valid = () => this.isConnected && this.version === version;
      const abort = this.abort = new AbortController();
      this.timeout = setTimeout(() => { if (valid()) this.reset(); }, 20000);
      try {
        const response = await fetch(`https://global.contentdriver.com/pclan.com.au/mpns/${encodeURIComponent(sku)}.json`, { signal: abort.signal });
        if (!response.ok) throw new Error('No ContentDriver record');
        const record = await response.json();
        if (!valid()) return;
        if (!record?.token) throw new Error('No ContentDriver content');
        const api = await getRuntime();
        const Embed = await api.defineCustomElements();
        if (!valid()) return;
        const next = Boolean(api.useNext({ page: record.page, product: record.product }));
        const stage = document.createElement('div');
        // Render at the actual width before swapping out the Shopify description.
        stage.style.cssText = 'position:absolute;left:0;top:0;width:100%;visibility:hidden;pointer-events:none;';
        stage.setAttribute('aria-hidden', 'true');
        const options = {
          global: false, next, page: record.page, product: record.product,
          token: record.token, selector: null, style: record.style,
          onReady: () => {
            if (!valid()) { stage.remove(); return; }
            clearTimeout(this.timeout);
            stage.style.cssText = 'display:block;width:100%;';
            stage.removeAttribute('aria-hidden');
            this.fallback.hidden = true;
          }
        };
        if (!next) options.getHTML = () => api.fetchText(`https://dist.contentdriver.com.au/${api.interpretToken(record.token).prefix}/index.html`);
        const embed = new Embed(options);
        embed.style.display = 'block';
        stage.append(embed);
        this.stage = stage;
        this.append(stage);
      } catch (error) {
        if (valid()) this.reset();
      }
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.controller?.abort();
      this.observer?.disconnect();
      this.reset();
      this.currentSKU = undefined;
    }
  });
})();
